/**
 * Task 18 — row Total = amount / (1 − margin%).
 * Margin 0 or ≥ 100 keeps the amount (UI rejects ≥ 100 before save).
 */
export function sellPriceFromCost(amount: number, marginPct: number): number {
  if (!Number.isFinite(amount)) return 0;
  if (!Number.isFinite(marginPct) || marginPct <= 0 || marginPct >= 100) {
    return amount;
  }
  return amount / (1 - marginPct / 100);
}
